import { render, staticRenderFns } from "./AnswerSecretQuestion.vue?vue&type=template&id=6f1cf210&scoped=true&"
import script from "./AnswerSecretQuestion.vue?vue&type=script&lang=js&"
export * from "./AnswerSecretQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AnswerSecretQuestion.vue?vue&type=style&index=0&id=6f1cf210&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1cf210",
  null
  
)

export default component.exports